import {EventEmitter, Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AnteilseignerPercentageService {
  onPercentageChange: EventEmitter<unknown> = new EventEmitter(true);
}
